import Tr from 'translations/Translations';

const createItem = (value) => ({label: `${value} ${Tr('days')}`, value})

export const elements = {
	30: createItem(30),
	60: createItem(60),
	90: createItem(90),
	120: createItem(120),
	150: createItem(150),
}

export default Object.values(elements)
